import React, { Component } from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import { API } from '../../Logic/API';
import { Storage } from '../../Logic/Storage';
import { GAME_ID, GROUP_ID, GROUP_NAME } from '../../Logic/storageKeys';
import "../Spacing.css";

export class JoinGroup extends Component {
    static displayName = JoinGroup.name;

    constructor(props) {
        super(props);

        let gameId = Storage.getValue(GAME_ID);
        this.state = { gameId , groupId : null, pin: null, groups: [], loading: true, joinFailed : false };

        this.props.showHostingNav(false);

        API.get(`/games/${gameId}/groups`)
            .then(resp => resp.json())
            .then(data => {
                this.setState({ groups: data, loading: false });
            })
            .catch(e => {

            });
    }
    
    selectGroup(group) {
        Storage.setSessionValue(GROUP_ID, group.Id);
        Storage.setSessionValue(GROUP_NAME, group.Name);
        this.setState({ groupId: group.Id });
    }

    pinChanged(pin) {
        this.setState({ pin });
    }

    canJoin() {
        return this.state.groupId !== null
            && this.state.pin !== null && this.state.pin.length > 0;
    }

    tryJoin() {
        if (!this.canJoin()) {
            return;
        }
        let content = {
            'GroupId': this.state.groupId,
            'Pin': this.state.pin
        };
        API.post(`/games/${this.state.gameId}/join`, content)
            .then(resp => resp.json())
            .then(data => {
                this.handleJoin(data);
            })
            .catch(e => {
                this.setState({ joinFailed: true });
            });
    }

    handleJoin(data) {
        if (data.Token === null) {
            return;
        }
        Storage.setSecurityToken(data.Token);
        this.props.history.push('/play/game');
    }

    renderElement(element) {
        return (
            <Row>
                <Col className="hidden-md"></Col>
                <Col lg="6"><div className="space-top space-bottom">{element}</div></Col>
                <Col className="hidden-md"></Col>
            </Row>
        );
    }

    renderLoadingMessage() {
        return this.renderElement(
            <p className='text-lg-center'><em>Lade Gruppen...</em></p>
        );
    }

    renderGroups(groups) {
        if (groups.length === 0) {
            return this.renderElement(
                <p className='text-lg-center'><em>Keine Gruppen gefunden</em></p>
            );
        }

        return this.renderElement(
            <ListGroup>
                {groups.map(group =>
                    <ListGroupItem key={group.Id} onClick={() => this.selectGroup(group)} active={this.state.groupId === group.Id}>
                        <p className="font-weight-bold text-lg-center">{group.Name}</p>
                    </ListGroupItem>
                )}
            </ListGroup>
        );
    }
    
    render() {
        let availableGroups = this.state.loading
            ? this.renderLoadingMessage()
            : this.renderGroups(this.state.groups);

        return (
            <Container>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6"><h2 className="text-lg-center space-top space-bottom">Gruppe wählen</h2></Col>
                    <Col className="hidden-md"></Col>
                </Row>
                {availableGroups}
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6">
                        <FormGroup>
                            <Label for="pinInput">PIN</Label>
                            <Input type="password" id="pinInput" placeholder="PIN" onChange={e => this.pinChanged(e.target.value)} />
                            {this.state.joinFailed &&
                                <FormFeedback>Beitreten fehlgeschlagen. Neuer Versuch!</FormFeedback>
                            }
                        </FormGroup>
                        <Button type="button" color={this.canJoin() ? "primary" : "secondary"} size="lg" block disabled={!this.canJoin()} onClick={() => this.tryJoin()}>Beitreten</Button>
                    </Col>
                    <Col className="hidden-md"></Col>
                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Game/JoinGroup.jsx